import React, { Component } from 'react';
import { change, Field, reduxForm } from 'redux-form';
import { browserHistory } from 'react-router';
import withNotify from '../common/withNotify';
import withLoader from '../common/withLoader';
import withOnline from '../common/withOnline';
import {
  passwordExtraMatches,
  passwordMaxLength,
  passwordsMustMatch,
  renderField,
  required
} from '../helpers/form-validations';
import PasswordRequirements from '../components/Models/PasswordRequirements';
import Header from '../components/Header';
import { changePassword } from '../utils/utils';
import {
  encryptPassword,
  passwordWithTimestamp,
  onGoBack,
  getUserNameAndPassword,
  storeUserNameAndPassword
} from '../common/globals';
import withGoBack from '../common/withGoBack';
import Bugsnag from '../helpers/bugsnag';
// import { APP_VERSION } from '../common/config';

class ChangePassword extends Component {
  _onSubmitPassword = (formData) => {
    try {
      const {
        setLoader, notify, online
      } = this.props;
      const changePasswordData = {
        userId: formData.userId,
        password: encryptPassword(passwordWithTimestamp(formData.currentPassword)),
        newPassword: encryptPassword(passwordWithTimestamp(formData.password)),
        // lastAppVersion: APP_VERSION,
      };
      const userNameAndPassword = {
        userId: formData.userId,
        password: formData.password
      };
      storeUserNameAndPassword(userNameAndPassword);
      if (online) {
        setLoader(true);
        changePassword(changePasswordData).then(async (responseJson) => {
          setLoader(false);
          const { message, status } = responseJson;
          if (status) {
            if (message.length > 0) {
              // notify({ type: 'success', message });
            }
            browserHistory.push('/');
          } else {
            notify({
              type: 'error',
              // message: 'Must be at least 8 characters long. Must contain an uppercase letter,
              // a lowercase letter, and a number. Password cannot be reused'
              message: responseJson.message
            });
          }
        });
      } else {
        notify({ type: 'error', message: 'You must an internet connection to Log In. Please check your connection and try again.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  async UNSAFE_componentWillMount() {
    try {
      const { dispatch } = this.props;
      const getUserName = await getUserNameAndPassword();
      Object.keys(getUserName).map(() => {
        dispatch(change('ChangePasswordForm', 'userId', getUserName.userId));
        dispatch(change('ChangePasswordForm', 'currentPassword', getUserName.password));
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { handleSubmit, goBack } = this.props;
    return (
      <div className="site-wrapper">
        <Header
          title="Change Password"
          goBack={() => onGoBack(goBack)}
        />
        <section className="login-section">
          <div className="container">
            <div className="row justify-content-center gx-2">
              <div className="col-12 col-md-5 col-lg-4 col-xl-3">
                <form onSubmit={handleSubmit(this._onSubmitPassword)} form="ChangePasswordForm">
                  <div className="case-data mt-5">
                    <label htmlFor="userId">User ID</label>
                    <Field
                      type="text"
                      name="userId"
                      className="form-control"
                      placeholder="User ID"
                      component={renderField}
                      validate={[required]}
                    />
                  </div>
                  <div className="case-data pt-3">
                    <label htmlFor="currentPassword">Current Password</label>
                    <Field
                      type="password"
                      name="currentPassword"
                      className="form-control"
                      placeholder="Current Password"
                      component={renderField}
                      validate={[required]}
                    />
                  </div>
                  <div className="case-data pt-3">
                    <label htmlFor="password">New Password</label>
                    <Field
                      type="password"
                      name="password"
                      className="form-control"
                      placeholder="Password"
                      component={renderField}
                      validate={[required, passwordMaxLength, passwordExtraMatches]}
                    />
                    <Field
                      type="password"
                      name="repeatPassword"
                      className="form-control"
                      placeholder="Repeat Password"
                      component={renderField}
                      validate={[required, passwordsMustMatch]}
                    />
                  </div>
                  <div className="case-data pt-5 mb-4">
                    <button type="submit" className="btn btn-theme btn-theme-alt w-100">Change Password</button>
                  </div>
                  <div className="row gx-2">
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-theme-alt btn-theme-outline-alt w-100"
                        data-bs-toggle="modal"
                        data-bs-target="#passwordRequirements"
                      >Password Requirements
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <PasswordRequirements />
      </div>
    );
  }
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'ChangePasswordForm',
});

export default withOnline(
  withGoBack(
    withForm(
      withNotify(
        withLoader(
          ChangePassword
        )
      )
    )
  )
);
